import { useMemo, useState } from 'react';
import { AgGridReact } from 'ag-grid-react'; // the AG Grid React Component
import 'ag-grid-enterprise';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import 'ag-grid-community/styles/ag-theme-material.css';
import { useDispatch, useSelector } from 'react-redux';
import { getSmartSequence } from '../../redux/selector';
import useFetchIfNeeded from '../../redux/useFetchIfNeeded';
import { fetchDataAndUpdateStore } from '../../redux/actions';
import { campaignInputData, opportunityInputData } from '../../shared/constants';
import { DateTimeFormatter } from '../../shared/controls/formatters';
import { useNavigate } from 'react-router-dom';
import apiServices from '../../services/service';
import { toast } from 'react-toastify';

const SmartSequence = () => {
  const containerStyle = useMemo(() => ({ width: '100%', height: '100%' }), []);
  const [selectedTheme, setSelectedTheme] = useState('balham');
  const [gridParams, setGridParams] = useState(null);
  const rowData = useSelector(getSmartSequence);
  const navigate = useNavigate();
  const [loading, setLoading] = useState();
  const dispatch = useDispatch();


  useFetchIfNeeded(getSmartSequence, fetchDataAndUpdateStore, {
    key: 'smartSequence',
    inputData: opportunityInputData,
  });
  const isMobile = () => {
    return window.innerWidth <= 767;
  };

  const handleClickDelete = (paramsValue) => {
    setLoading(true);
    // Creating the desired JSON object
    const data = {
      id: [paramsValue.id],
    };
    apiServices
      .deleteSmartSequence(data)
      .then((response) => {
        if (response.status === 200) {
          if (paramsValue.id === undefined) {
            document.getElementById('massDeleteModal').click();
          }
          dispatch(
            fetchDataAndUpdateStore({
              key: 'smartSequence',
              inputData: campaignInputData,
            })
          );

          // setUpdateListFlag(true);
          setLoading(false);
          toast.success('Smart Sequence Deleted Successfully!', {
            position: 'top-right',
          });
        } else {
          setLoading(false);
          toast.error('Error deleting record', {
            position: 'top-right',
          });
        }
      })
      .catch((error) => {
        console.error('Error deleting record:', error);
        setLoading(false);
      });
  };

  const sideBar = useMemo(() => {
    return {
      toolPanels: [
        {
          id: 'columns',
          labelDefault: 'Columns',
          labelKey: 'columns',
          iconKey: 'columns',
          toolPanel: 'agColumnsToolPanel',
          minWidth: 225,
          width: 225,
          maxWidth: 225,
          toolPanelParams: {
            suppressPivotMode: true, // 👈 Hide Pivot Mode toggle
            suppressRowGroups: false, // ✅ Allow row grouping
            suppressValues: false, // ✅ Allow aggregation if needed
            suppressPivots: true, // 👈 Hide the pivot section for columns
          },
        },
        {
          id: 'filters',
          labelDefault: 'Filters',
          labelKey: 'filters',
          iconKey: 'filter',
          toolPanel: 'agFiltersToolPanel',
          minWidth: 180,
          maxWidth: 400,
          width: 250,
        },
      ],
      position: 'left',
      defaultToolPanel: 'none', //show off filter tab bydefault.
    };
  }, []);
  /***********for AgGrid********** */
  // const [rowData] = useState([
  //   {
  //     id: 1,
  //     sequenceName: 'Welcome Campaign',
  //     type: 'Email',
  //     owner: 'Alice',
  //     status: 'Active',
  //     startDate: '2024-01-01',
  //     endDate: '2024-01-10',
  //     totalSent: 1000,
  //     openRate: 60,
  //     replyRate: 15,
  //     createdDate: '2023-12-15',
  //   },
  //   {
  //     id: 2,
  //     sequenceName: 'Follow-Up Series',
  //     type: 'Email',
  //     owner: 'Bob',
  //     status: 'Paused',
  //     startDate: '2024-02-01',
  //     endDate: '2024-02-20',
  //     totalSent: 500,
  //     openRate: 45,
  //     replyRate: 10,
  //     createdDate: '2024-01-20',
  //   },
  //   {
  //     id: 3,
  //     sequenceName: 'Product Updates',
  //     type: 'Email',
  //     owner: 'Charlie',
  //     status: 'Draft',
  //     startDate: '-',
  //     endDate: '-',
  //     totalSent: 0,
  //     openRate: 0,
  //     replyRate: 0,
  //     createdDate: '2024-03-01',
  //   },
  // ]);

  const [columnDefs] = useState([
    {
      headerName: 'Action',
      field: 'action',
      cellRenderer: (params) => {
        const rowData = { ...params.data, rowIndex: params.rowIndex };
        return (
          <div className="action-menu">
            <img
              src="/assets/images/edit.png"
              className="action-img1"
              onClick={() =>
                navigate(`/campaigns/editSmartSequence`, {
                  state: rowData,
                })
              }
              alt="Edit Smart Sequence"
              title="Edit Smart Sequence"
            ></img>
            <img
              src="/assets/images/view.png"
              className="action-img2"
              alt="View Smart Sequence"
              title="View Smart Sequence"
              onClick={() =>
                navigate(`/campaigns/viewSmartSequence`, {
                  state: rowData,
                })
              }
            ></img>
            <img
              src="/assets/images/trash.png"
              className="action-img2"
              onClick={() => handleClickDelete(params.data)}
              alt="Delete Smart Sequence"
              title="Delete Smart Sequence"
            ></img>
          </div>
        );
      },
      maxWidth: 100,
      minWidth: 100,
      sortable: false,
      filter: false,
      pinned: true,
    },
    {
      headerName: 'Sequence Name',
      field: 'sequenceName',
      pinned: isMobile() ? null : 'left',
      minWidth: 180,
    },
    { headerName: 'Type', field: 'sequenceType' },
    { headerName: 'Owner', field: 'sequenceOwner' },
    {
      headerName: 'Status',
      field: 'status',
      cellStyle: (params) => ({
        color:
          params.value === 'Active'
            ? 'green'
            : params.value === 'Paused'
              ? 'orange'
              : params.value === 'Draft'
                ? 'gray'
                : 'black',
        fontWeight: 'bold',
      }),
    },
    {
      headerName: 'ScheduledDateTime',
      field: 'scheduledDateTime',
      valueFormatter: DateTimeFormatter,
    },
    // {
    //   headerName: 'Total Sent',
    //   field: 'totalSent',
    //   type: 'numericColumn',
    // },
    {
      headerName: 'Max Recipients Per Batch',
      field: 'maxRecipientsPerBatch',
    },
    // {
    //   headerName: 'Open Rate',
    //   field: 'openRate',
    //   valueFormatter: (params) => `${params.value}%`,
    // },
    // {
    //   headerName: 'Reply Rate',
    //   field: 'replyRate',
    //   valueFormatter: (params) => `${params.value}%`,
    // },
    {
      headerName: 'Created Date Time ',
      field: 'createdDateTime',
      valueFormatter: DateTimeFormatter,
    },
    {
      headerName: 'Updated Date Time ',
      field: 'updatedDateTime',
      valueFormatter: DateTimeFormatter,
    },
  ]);

  const defaultColDef = useMemo(() => ({
    sortable: true,
    editable: false,
    flex: 1,
    minWidth: 130,
    filter: true,
    resizable: true,
    enableValue: true,
    enableRowGroup: true,
    enablePivot: true,
  }));

  return (
    <div className="cutome_ag_theme">
      <div
        className={`ag-theme-${selectedTheme} tbl_height`}
        style={{ width: '100%', height: `calc(100vh - 136px)` }}
      >
        <AgGridReact
          domLayout="fixedHeight"
          rowData={rowData}
          columnDefs={columnDefs}
          defaultColDef={defaultColDef}
          animateRows={true}
          rowSelection={'multiple'}
          sideBar={sideBar}
          enableRangeSelection={true}
          suppressExcelExport={true}
          suppressRowClickSelection={true}
          groupSelectsChildren={true}
          pivotPanelShow={'always'}
        />
      </div>
    </div>
  );
};

export default SmartSequence;
